module.exports = __webpack_public_path__ + "static/media/event_cooking.a73cc210.jpg";